import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";

import Onboard from "components/Onboard";
import PrivateRoutes from "components/PrivateRoutes";

import FileSplit from "pages/file-split/file-split";
import MoveFiles from "pages/file-move/file-move";
import ProfileFiles from "pages/data-profiling/data-profiling";
import Config from "pages/config/config";
import FileMasks from "pages/file-masks/file-masks";
import FileMappings from "pages/file-mappings/file-mappings";
import FaoCreate from "pages/fao-builder/fao-create";
import FaoMetadata from "pages/fao-builder/fao-metadata";
import FaoCreateImport from "pages/fao-builder/fao-create-import";
import FaoView from "pages/fao-builder/fao-view";
import FaoAwardingStrategy from "pages/fao-builder/fao-awardingstrategy";
import ListUploads from "pages/list-plus/list-uploads/list-uploads";
import Batch from "pages/list-plus/batch/batch";
import SchoolSettings from "pages/school-settings/school-settings";
import FaoClone from "pages/fao-builder/fao-clone";
import appRoles from "config/appRoles";
import FaoRegimeParams from "pages/fao-builder/fao-regime/fao-regime-params";
import FaoRegimeConfig from "pages/fao-builder/fao-regime/fao-regime-config";
import FaoTuition from "pages/fao-builder/fao-tuition/fao-tuition";
import FaoBuilderLayout from "pages/fao-builder/fao-layout/fao-builder-layout";
import FaoEdit from "pages/fao-builder/fao-edit";
import FaoCheckout from "pages/fao-builder/fao-checkout";
import FaoViewResults from "pages/fao-builder/fao-view-results";

const ClientHomeRoutes = () => (
  <Routes>
    <Route
      element={<PrivateRoutes allowedAppRoles={appRoles.IsFileSplitReader} />}
    >
      <Route path="file-split/*" element={<FileSplit />} />
    </Route>
    <Route
      element={<PrivateRoutes allowedAppRoles={appRoles.IsFileMoverReader} />}
    >
      <Route exact path="move-files/*" element={<MoveFiles />} />
    </Route>
    <Route
      element={<PrivateRoutes allowedAppRoles={appRoles.IsFileSplitReader} />}
    >
      <Route exact path="data-profiling/*" element={<ProfileFiles />} />
    </Route>
    <Route
      element={<PrivateRoutes allowedAppRoles={appRoles.IsConfigReader} />}
    >
      <Route exact path="config/*" element={<Config />}></Route>
    </Route>
    <Route
      element={<PrivateRoutes allowedAppRoles={appRoles.IsFileSetupReader} />}
    >
      <Route exact path="file-masks/*" element={<FileMasks />} />
      <Route exact path="file-mappings/*" element={<FileMappings />} />
    </Route>
    <Route
      element={<PrivateRoutes allowedAppRoles={appRoles.IsFaoBuilderReader} />}
    >
      <Route element={<FaoBuilderLayout />}>
        <Route
          path="fao-builder/*"
          element={<Navigate from="fao-builder" to="create" />}
        />
        <Route exact path="fao-builder/create" element={<FaoCreate />} />
        <Route exact path="fao-builder/clone" element={<FaoClone />} />
        <Route
          exact
          path="fao-builder/:modelId/metadata"
          element={<FaoMetadata />}
        />
        <Route
          exact
          path="fao-builder/:modelId/import"
          element={<FaoCreateImport />}
        />
        <Route
          exact
          path="fao-builder/:modelId/regime-param"
          element={<FaoRegimeParams />}
        />
        <Route
          exact
          path="fao-builder/:modelId/tuition"
          element={<FaoTuition />}
        />
        <Route
          exact
          path="fao-builder/:modelId/checkout"
          element={<FaoCheckout />}
        />
        <Route
          exact
          path="fao-builder/:modelId/regime-config"
          element={<FaoRegimeConfig />}
        />
        <Route
          exact
          path="fao-builder/:modelId/awarding-strategy"
          element={<FaoAwardingStrategy />}
        />
        <Route
          exact
          path="fao-builder/fao-view-results"
          element={<FaoViewResults />}
        />
        <Route exact path="fao-builder/fao-view" element={<FaoView />} />
        <Route exact path="fao-builder/fao-edit" element={<FaoEdit />} />
      </Route>
    </Route>
    <Route element={<PrivateRoutes allowedAppRoles={appRoles.IsAtomUser} />}>
      <Route exact path="onboard/*" element={<Onboard />} />
    </Route>
    <Route
      element={<PrivateRoutes allowedAppRoles={appRoles.IsListPlusReader} />}
    >
      <Route
        path="list-plus/*"
        element={<Navigate from="list-plus" to="list-uploads" />}
      />
      <Route exact path="list-plus/list-uploads/*" element={<ListUploads />} />
      <Route
        exact
        path="list-plus/list-uploads/batch/:batchId/*"
        element={<Batch />}
      />
    </Route>
    <Route element={<PrivateRoutes allowedAppRoles={appRoles.IsAtomUser} />}>
      <Route exact path="school-settings/*" element={<SchoolSettings />} />
    </Route>
  </Routes>
);

export default ClientHomeRoutes;
